import React from 'react';
import {Alert, Checkbox, Link, TextField, Typography} from "@bonprix/design-system";
import AvailabilityReminderSizeSelection from "./AvailabilityReminderSizeSelection.jsx";

export default function AvailabilityReminderContent({
                                                        facadeError,
                                                        newsletterSubscriptionErrors,
                                                        showSuccessLayer,
                                                        texts,
                                                        currentItem,
                                                        currentItemOption,
                                                        availabilityReminderEmail,
                                                        isEmailError,
                                                        isNewsletter,
                                                        onTextInput,
                                                        onCheckboxChange,
                                                        sizeSelected
}) {

    const checkboxLabel = (
        <Typography variant="body2" color="on-bg-mid">
            {texts.bff_newsletter_checkbox_text_1_4}<b>{texts.bff_newsletter_checkbox_text_2_4}</b>
            <br/>
            {texts.bff_newsletter_checkbox_text_3_4}
            <Link small href={texts.bff_newsletter_checkbox_unsubscribe_link}>
                {texts.bff_newsletter_checkbox_text_4_4}
            </Link>
            {'.'}
        </Typography>
    );

    return <>
        {facadeError && (
            <div className="availability-reminder__error">
                <Alert isOpen={facadeError} severity="error" showCloseIcon={false}>
                    {texts.availability_reminder_subscription_error_message}
                </Alert>
            </div>
        )}
        {newsletterSubscriptionErrors && (
            <div className="availability-reminder__error">
                <Alert isOpen={facadeError} severity="error" showCloseIcon={false}>
                    {texts.newsletter_subscription_not_successful}
                </Alert>
            </div>
        )}
        {showSuccessLayer ? (
            <Typography variant="body1">
                {texts.bff_wishlist_availability_reminder_success_pretext}{' '}
                <Typography component="span" variant="body1-bold">
                    {availabilityReminderEmail}
                </Typography>{' '}
                {texts.bff_wishlist_availability_reminder_success_posttext}
            </Typography>
            ) : (
            <>
                <div className="availability-reminder__text">
                    {currentItemOption &&
                        <div className="availability-reminder__text-intro">
                            <Typography variant="body1">
                                {texts.bff_availability_reminder_size_not_available.replace("{0}", currentItemOption.name)}
                            </Typography>
                        </div>
                    }
                    <Typography variant="body1">{texts.ada_matrix_text_short}</Typography>
                </div>

                {currentItemOption === null &&
                    <AvailabilityReminderSizeSelection
                        texts={texts}
                        activeItem={currentItem}
                        activeItemOptionIndex={sizeSelected ? currentItem.itemOptions.findIndex(o => o.id === currentItemOption?.Id) : null}
                        sizeSelected={sizeSelected}
                    />
                }

                <div className="availability-reminder__form">
                    <TextField value={availabilityReminderEmail}
                               error={isEmailError}
                               errorText={isEmailError ? texts['contactForm.invalid_email'] : null}
                               inputMode="email"
                               label={texts.footer_newsletter_placeholder}
                               onChange={onTextInput}
                    />
                </div>

                <div className="availability-reminder__checkbox">
                    <Typography variant="body2" color="on-bg-mid">Newsletter</Typography>
                    <Checkbox label={checkboxLabel}
                              name="newsletter"
                              checked={isNewsletter}
                              onChange={onCheckboxChange}
                    />
                </div>
            </>
        )}
    </>
}
